import { LOGIN } from '@/constants/routes';
import { useUserStore } from '@/stores/user';

export default async function loadProfile() {
  const userStore = useUserStore();
  const isProfileLoaded = Object.keys(userStore.user).length > 0;

  if (!isProfileLoaded) {
    try {
      await userStore.fetchUser();
      return true;
    } catch {
      return { name: LOGIN };
    }
  }

  return true;
}
